export const SICREDI_LOGO_VERDE = 'verde'
export const SICREDI_LOGO_BRANCO = 'branco'

export const HeaderThemes = [SICREDI_LOGO_BRANCO, SICREDI_LOGO_VERDE]


export type HeaderThemeType = typeof HeaderThemes[number]